import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedService } from '../../_services/shared.service';

@Component({
  selector: 'app-reports',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './reports.component.html',
  styleUrl: './reports.component.scss'
})
export class ReportsComponent {
  reportLists: any;
  sharedService = inject(SharedService);

  ngOnInit() {
    this.getReportsList();
  }

  getReportsList() {
    this.reportLists = this.sharedService.reportLists;
  }

}
